export default "__VITE_ASSET__DcCht__7__"